module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-LightItalic-WebXL-45158105b0be6f4869a890f399a3e60d.woff2";